export const APP_COMPONENT_EVENTS = {
  COMPONENT_ON_MOUNT: "componentOnMount",
  COMPONENT_ON_UNMOUNT: "componentOnUnMount",
  CC_ON_PARAMS_CHANGE: "onCustomComponentParamsChange"
};

export const APP_VARIABLE_TYPE = {
  GLOBAL: "global",
  LOCAL: "local"
};
